import React from 'react'
import { styled } from '../../../stitches.config'
import LazyLoad from "react-lazyload"

import OnnetworkVideo from './OnnetworkVideo'

import FacebookPost from '../Content/body/FacebookPost'
import TwitterPost from '../Content/body/TwitterPost'
import InstagramPost from '../Content/body/InstagramPost'
import GoogleMaps from '../Content/body/GoogleMaps'
import TiktokEmbed from '../Content/body/TiktokEmbed'

const regexOnnetwork = /(?:https?:\/\/video.onnetwork.tv\/embed.php\?)?(?:sid=)?(\w{4,15}==)/;
const regexInsta = /https?:\/\/www\.instagram\.com\/p\/([^/?&]+)\/?/;
const regexTwitter = /^https?:\/\/(?:twitter|x)\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+)(?:\/.*)?$/;

const Embed = ({ blockData }) => {
    const { embed, caption, service, source } = blockData;
    return <LazyLoad once={true} offset={400} height={500}>
        <EmbedWrapper>
            {(() => {
                switch (service) {
                    case "onnetwork_script":
                        let mid = source.match(regexOnnetwork);
                        return <OnnetworkVideo mid={mid[1]} />
                    case "instagram":
                        let dataIdInsta = source.match(regexInsta)
                        return <InstagramPost dataId={dataIdInsta[1]} />
                    case "twitter":
                        let dataIdTwitter = blockData.id;
                        let sourceMatchTwitter = source.match(regexTwitter);
                        if (sourceMatchTwitter && sourceMatchTwitter[2]) {
                            dataIdTwitter = sourceMatchTwitter[2];
                        }
                        return <TwitterPost dataId={dataIdTwitter} />
                    case "facebook_post":
                    case "facebook_comment":
                        return <FacebookEmbedWrapper>
                            <FacebookPost href={source} />
                        </FacebookEmbedWrapper>
                    case "google_maps":
                        return <GoogleMaps src={embed} />
                    case "youtube":
                        return <PlayerWrapper type="youtube">
                            <iframe
                                src={embed}
                                frameborder="0"
                                allow="autoplay; encrypted-media" allowfullscreen>
                            </iframe>
                        </PlayerWrapper>
                    case "onnetwork_iframe":
                        return <PlayerWrapper type="onnetwork">
                            <iframe
                                src={embed}
                                frameborder="0"
                                allow="autoplay; encrypted-media" allowfullscreen>
                            </iframe>
                        </PlayerWrapper>
                    case "tiktok":
                        return <TiktokEmbed profile={blockData.profile} videoId={blockData.videoId} />
                    default:
                        return <EmbedDefaultWrapper>
                            <iframe
                                src={embed}
                                width={blockData.width}
                                height={blockData.height}
                                frameborder="0"
                                allow="autoplay; encrypted-media" allowFullScreen>
                            </iframe>
                        </EmbedDefaultWrapper>
                }
            })()}
            {caption !== "" && <EmbedCaption>{caption}</EmbedCaption>}
        </EmbedWrapper>
    </LazyLoad>

}

const EmbedDefaultWrapper = styled("div", {
    margin: "38px !important",
    "@bp4": {
        margin: "0 auto !important",
        maxWidth: "660px !important"
    },
    "& > iframe": {
        maxWidth: "100%"
    }
});

const PlayerWrapper = styled("div", {
    position: "relative",
    paddingBottom: "56.25%",
    paddingTop: "25px",
    margin: "20px 0",
    variants: {
        "type": {
            "youtube": {
                "@bp4": {
                    width: "861px !important",
                    height: "474px",
                    minHeight: "474px"
                },
                "& > iframe": {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                }
            },
            "onnetwork": {
                "& > iframe": {
                    position: "relative",
                    paddingBottom: "56.25%",
                    paddingTop: "25px",
                    margin: "20px 0"
                }
            }
        }
    }
});

const EmbedWrapper = styled("div", {
    margin: "30px auto",
    "@bp4": {
        "& > div": {
            margin: "0 auto",
            width: "auto",
            maxWidth: "780px",
            paddingBottom: "0",
            height: "auto"
            /* width: 861px; */
            /* min-height: 474px; */
        }
    }
});

const FacebookEmbedWrapper = styled("div", {
    /*
     @media (max-width: 575px) {
     margin-left: -32px; 
     transform: scale(0.78); 
     }
     */
});

const EmbedCaption = styled("p", {
    textAlign: "center",
    fontStyle: "italic",
    margin: "30px auto 0 auto",
    "@bp4": {
        width: "861px"
    }
});

export default Embed;